import React from 'react';
import { colors } from 'seedling/constants';

type Props = {
  size: string,
};

function ContactsIcon({ size = '20' }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.798 3.7h.973c.402 0 .729.326.729.728v14.344a.729.729 0 01-.73.728H4.743A2.24 2.24 0 012.5 17.262V2.92C2.5 1.579 3.48.5 4.742.5h10.327c.402 0 .729.326.729.728v2.473zM3.958 5.03v12.232c0 .432.352.782.784.782h11.3V5.156h-11.3a2.41 2.41 0 01-.784-.127zm4.252 5.965a2.617 2.617 0 012.026-4.274 2.617 2.617 0 012.007 4.295c1.23.692 2.096 2.054 2.096 3.981v.728H6.075v-.728c0-1.947.885-3.318 2.135-4.002zm2.025-.5a1.16 1.16 0 100-2.319 1.16 1.16 0 100 2.319zm2.587 3.774c-.262-1.535-1.362-2.318-2.615-2.318-1.253 0-2.353.782-2.615 2.318h5.23zM4.742 1.956h9.598V3.7H4.741c-.48 0-.784-.29-.784-.792 0-.556.36-.952.784-.952z"
        fill={colors.mediumGrey}
      />
    </svg>
  );
}

export default ContactsIcon;
